<template>
  <div class="releasedDetail mainContainer">
    <div class="distributionBox">
      <el-form v-model="form" label-width="80px">
        <div class="title">
          <span class="address">{{ detailData.city }}</span>
          {{ detailData.title }}
        </div>
        <div class="personInformationBox">
          <div>
            <img class="headImg" src="../../assets/img/paihuo/paihuo_touxiang_default.png"
                 v-if="!detailData.headImg">
            <img :src="detailData.headImg" v-else class="headImg" @click.stop="imagePreview(detailData.headImg)">
          </div>
          <div class="personInformation">
            <div class="name ">{{ detailData.name }}</div>
            <div class="informationBox">
              <div class="information" v-for="(val, ind) in detailData.datas" :key="ind" v-if="val.id !== 'score'">
                <span>{{ val.key }} </span>
                {{ val.value }}
              </div>
              <div class="WRAST" v-for="(val, ind) in detailData.datas" :key="ind" v-if="val.id === 'score'">
                <span class="text">{{ val.key }} </span>
                <span class="WRASText" v-if="val.value.socreLevel == -1">黑名单</span>
                <span class="WRASText" v-if="val.value.socreLevel == 0">信用未评级</span>
                <img src="../../assets/img/paihuo/star_one.png" class="star_one"
                     v-if="val.value.starCount === 1">
                <img src="../../assets/img/paihuo/star_two.png" class="star_two"
                     v-if="val.value.starCount === 2">
                <img src="../../assets/img/paihuo/star_three.png" class="star_three"
                     v-if="val.value.starCount === 3">
                <img src="../../assets/img/paihuo/star_four.png" class="star_four"
                     v-if="val.value.starCount === 4">
                <img src="../../assets/img/paihuo/star_five.png" class="star_five"
                     v-if="val.value.starCount === 5">
              </div>
            </div>
          </div>
        </div>
        <el-form-item label="介绍">
          <span class="content">{{detailData.content}}</span>
        </el-form-item>
        <div class="buttom">
          <el-button class="btnHeight_40 btWith_120 " type="primary"  @click="jobDelete">删除</el-button>
          <el-button class="btnHeight_40  btWith_120 mg_left_40" type="warning"  @click="advertiseSeekers">重新发布</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { findJobFindJob, findJobPublish, findJobDelete } from '@api/zhaohuo'
export default {
  name: 'releasedDetail',
  data () {
    return {
      detailData: {}
    }
  },
  created () {
    this.getFindJobInit()
  },
  methods: {
    getFindJobInit () {
      findJobFindJob({
        city: ''
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    jobDelete () {
      findJobDelete().then(res => {
        if (res.data.code === 200) {
          this.$message.success('删除成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 发布找活广告
    advertiseSeekers () {
      findJobPublish({
        content: this.detailData.content,
        defaultCity: this.detailData.defaultCity,
        title: this.detailData.title,
        isDefalult: 1
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success('发布成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.releasedDetail{
  padding: 24px;
  .buttom{
    width: 280px;
    margin: 60px auto;
    margin-top: 120px;
  }
  .personInformationBox{
    border-bottom: none;
    .informationBox{
      display: flex;
    }
  }
  .title{

    color: #333333;
    font-size: 24px;
  }
  .address{
    color: #0368C1;
  }
  .content{

    font-size: 16px;
    color: #333333;
  }
}
</style>
